/*global google*/
import React from 'react';
import axios from "axios";
import Select, { components } from "react-select";
import { useState, useEffect, useRef, useMemo } from 'react';
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarNew from '../NewAdminPanel/Common/AdminSidebarMnt';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import { set } from 'date-fns';

const MachinSurveyReport = () => {
    const [optionState, setOptionState] = useState([]);
    const [stateValue, setStateValue] = useState([]);
    const [optionDistrict, setOptionDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState('');
    const [optionSubDistrict, setOptionSubDistrict] = useState([]);
    const [subdistrictValue, setsubDistrictValue] = useState('');
    const [optionVillage, setOptionVillage] = useState([]);
    const [villageValue, setvillageValue] = useState('');
    const [selectedDataSetDistrict, setselectedDataSetDistrict] = useState('');
    const [selectedDataSetSubDistrict, setselectedDataSetSubDistrict] = useState('');
    const [selectedDataSetVillage, setselectedDataSetVillage] = useState('');
    const [selectedFinYear, setSelectedFinYear] = useState('All');
    const [finYear, setFinYear] = useState('');
    const [selectedUserType, setSelectedUserType] = useState('');
    const [selectedIcarOrgType, setSelectedIcarOrgType] = useState('All'); // ATARI | KVK | All (only for ICAR filter)
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [rows, setRows] = useState([]);
    // For Central (role "1"): hide table until Submit is clicked
    const [hasSearched, setHasSearched] = useState(() => {
        const role = sessionStorage.getItem("userRoleCodeModel");
        return role !== "1"; // non-Central users see auto-loaded data immediately
    });
    const [isStateFrozen, setIsStateFrozen] = useState(false);
    const [isDistrictFrozen, setIsDistrictFrozen] = useState(false);
    const [desiredDistrictCode, setDesiredDistrictCode] = useState(null);
    const [isStateOrDistrictUser, setIsStateOrDistrictUser] = useState(false);
    const hasCalledStateUserApi = useRef(false);
    const hasCalledIcarUserApi = useRef(false);
    const hasCalledAtariUserApi = useRef(false);
    const hasCalledKvkUserApi = useRef(false);
    
    // Modal states for implements
    const [showImplementsModal, setShowImplementsModal] = useState(false);
    const [selectedImplements, setSelectedImplements] = useState(null);
    
    // Modal states for polygon
    const [showPolygonModal, setShowPolygonModal] = useState(false);
    const [selectedPolygon, setSelectedPolygon] = useState(null);
    const [currentDetailImageIndex, setCurrentDetailImageIndex] = useState(0);
    const [imageRotations, setImageRotations] = useState({});
    const [polygonMap, setPolygonMap] = useState(null);
    const [polygonMapReady, setPolygonMapReady] = useState(false);

    // Dynamic map center from polygon coordinates
    const polygonMapCenter = useMemo(() => {
        if (!selectedPolygon?.polygonShape) return { lat: 28.6139, lng: 77.2090 };
        try {
            const raw = selectedPolygon.polygonShape;
            const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
            const arr = Array.isArray(parsed) ? parsed : [];
            if (arr.length === 0) return { lat: 28.6139, lng: 77.2090 };
            const sum = arr.reduce(
                (acc, p) => ({
                    lat: acc.lat + Number(p.lat ?? p.latitude ?? p.Lat ?? p.Latitude ?? 0),
                    lng: acc.lng + Number(p.lng ?? p.longitude ?? p.Lng ?? p.Longitude ?? 0),
                }),
                { lat: 0, lng: 0 }
            );
            return { lat: sum.lat / arr.length, lng: sum.lng / arr.length };
        } catch {
            return { lat: 28.6139, lng: 77.2090 };
        }
    }, [selectedPolygon]);

    const detailImages = useMemo(() => {
        if (!selectedPolygon?.imagePaths) return [];
        return String(selectedPolygon.imagePaths)
            .split(',')
            .map(path => path.trim())
            .filter(path => path);
    }, [selectedPolygon?.imagePaths]);

    const detailImageRotation = imageRotations[currentDetailImageIndex] || 0;
    const isDetailImageSideways = detailImageRotation % 180 !== 0;
    
    // Use REACT_APP_GOOGLE_MAPS_API_KEY from .env if set (recommended for higher quota/billing)
    const mapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
        || "AIzaSyD4X4kzlpReymgcXUXGh0Q3TalmxJmasM0";
    const { isLoaded, loadError } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: mapsApiKey,
    });
    const [atariValue, setAtariValue] = useState("NA");
    const [atariData, setAtariData] = useState([]);
    const [isAtariFrozen, setIsAtariFrozen] = useState(false);
    const [fmttiCentreValue, setFmttiCentreValue] = useState("NA");
    const [fmttiCentreData, setFmttiCentreData] = useState([]);
    const [isIcarFrozen, setIsIcarFrozen] = useState(false);
    const [isKvkFrozen, setIsKvkFrozen] = useState(false);
    const [kvkValue, setKvkValue] = useState("NA");
    const [kvkData, setKvkData] = useState([]);
    // table utilities: sorting and pagination
    const [sortKey, setSortKey] = useState('');
    const [sortDir, setSortDir] = useState('asc'); // 'asc' | 'desc'
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const baseUrl = `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}`;
    const [finYears, setFinYears] = useState(() => {
          const currentYear = new Date().getFullYear();
          const years = ["All"];
      
          // Add last 5 financial years
          for (let i = 0; i < 3; i++) {
            const startYear = currentYear - i;
            const endYear = startYear + 1;
            years.push(`${startYear}-${endYear}`);
          }
      
          return years;
        });

    const isIcarSelected = selectedUserType === '9';
    const isFmttiSelected = selectedUserType === '1';
    const isCrmSelected = selectedUserType === '2';
    const isIcarLogin = typeof sessionStorage !== 'undefined' &&
        ["9", "10", "11", "12"].includes(sessionStorage.getItem("userRoleCodeModel"));
    const isCentralLoginRole1 = typeof sessionStorage !== 'undefined' &&
        String(sessionStorage.getItem("userTypeCodeModel") ?? '').trim() === "1";
    const isStateLoginUserType2 = typeof sessionStorage !== 'undefined' &&
        String(sessionStorage.getItem("userTypeCodeModel") ?? '').trim() === "2";
    const isFmttiLoginUserType1 = typeof sessionStorage !== 'undefined' &&
        String(sessionStorage.getItem("userRoleCodeModel") ?? '').trim() === "6";

    // CRM + State-login: show only CRM allowed states
    const stateOptionsForUi = useMemo(() => {
        const base = Array.isArray(optionState) ? optionState : [];
        // Requirement: when Scheme Type = CRM, show only 5 allowed states
        // for Central login and State login (userTypeCodeModel=2).
        const shouldRestrict = isCrmSelected && (isCentralLoginRole1 || isStateLoginUserType2);
        if (!shouldRestrict) return base;

        const allowed = new Set(['DELHI', 'HARYANA', 'MADHYA PRADESH', 'PUNJAB', 'UTTAR PRADESH']);
        const filtered = base.filter(s => allowed.has(String(s.label ?? '').toUpperCase().trim()));

        // If a frozen/selected state is not in allowed list, keep it so dropdown doesn't go blank
        if (stateValue && stateValue.length > 0) {
            const current = base.find(s => String(s.value) === String(stateValue[0]));
            if (current && !filtered.some(s => String(s.value) === String(current.value))) {
                return [current, ...filtered];
            }
        }
        return filtered;
    }, [optionState, isStateLoginUserType2, isCrmSelected, stateValue]);

    const handleSchemeTypeChange = (opt) => {
        // FMTTI login: scheme type must remain FMTTI
        if (isFmttiLoginUserType1) return;
        const next = opt ? opt.value : '';
        setSelectedUserType(next);

        if (next === '9') {
            // ICAR: load Atari list and hide geo filters (we already conditionally hide in JSX)
            fetchAtariData();

            // Reset Atari/KVK selections only if not frozen (non-Atari login)
            if (!isAtariFrozen) {
                setAtariValue("NA");
                setAtariData([]);
                setKvkValue("NA");
                setKvkData([]);
            } else {
                // Atari is frozen: reload KVK data for the frozen Atari
                fetchKvkData(atariValue);
            }
            if (!isIcarFrozen) {
                setIsIcarFrozen(true); // Freeze ICAR selection once chosen
                setAtariValue("NA");
                setAtariData([]);
                setKvkValue("NA");
                setKvkData([]);
            } else {
                // Atari is frozen: reload KVK data for the frozen Atari
                fetchKvkData(atariValue);
            }

            // Clear geo filter selections to avoid mixing with ICAR
            setOptionDistrict([]);
            if (!isDistrictFrozen) setDistrictValue('');
            setOptionSubDistrict([]);
            setsubDistrictValue('');
            setOptionVillage([]);
            setvillageValue('');
            if (!isDistrictFrozen) setselectedDataSetDistrict('');
            setselectedDataSetSubDistrict('');
            setselectedDataSetVillage('');
        } else if (next === '1') {
            // FMTTI: load FMTTI centre list and reset Atari/KVK
            fetchFmttiCentreData();
            setFmttiCentreValue("NA");
            if (!isAtariFrozen) {
                setAtariValue("NA");
                setAtariData([]);
            }
            setKvkValue("NA");
            setKvkData([]);
        } else {
            // CRM / All: reset Atari/KVK and FMTTI centre
            setFmttiCentreValue("NA");
            setFmttiCentreData([]);
            if (!isAtariFrozen) {
                setAtariValue("NA");
                setAtariData([]);
            }
            setKvkValue("NA");
            setKvkData([]);
        }
    };

    // If state login is CRM (userTypeCodeModel=2), prevent FMTTI selection
    useEffect(() => {
        if (isStateLoginUserType2 && selectedUserType === '1') {
            setSelectedUserType('');
            setRows([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isStateLoginUserType2]);

    // If userTypeCodeModel=1 (FMTTI login), auto-select FMTTI and load centre list
    useEffect(() => {
        if (!isFmttiLoginUserType1) return;
        setSelectedUserType('1');
        fetchFmttiCentreData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFmttiLoginUserType1]);
    useEffect(() => {
        getStates();
        // Prefill and freeze based on user type (State/District/Atari)
        const userType = sessionStorage.getItem("userRoleCodeModel");
        const stateCodeStr = sessionStorage.getItem("stateCodeModel") || sessionStorage.getItem("stateNameModel");
        const districtCodeStr = sessionStorage.getItem("districtCodeModel") || sessionStorage.getItem("districtNameModel");
        const atariCodeStr = sessionStorage.getItem("atariCode");
        
        if (userType === "2" && stateCodeStr) { // State login
            const sc = Number(stateCodeStr);
            setStateValue([sc]);
            setIsStateFrozen(true);
            setIsStateOrDistrictUser(true);
            handleState(sc);
        }

        if (userType === "3" && stateCodeStr) { // District login
            const sc = Number(stateCodeStr);
            setStateValue([sc]);
            setIsStateFrozen(true);
            setIsStateOrDistrictUser(true);
            handleState(sc);

            if (districtCodeStr) {
                const hasMultipleDistricts = String(districtCodeStr).includes(',');
                
                if (hasMultipleDistricts) {
                    setIsDistrictFrozen(false);
                } else {
                    setDesiredDistrictCode(districtCodeStr);
                    setIsDistrictFrozen(true);
                }
            }
        }

        // Atari/KVK login: auto-select ICAR scheme type, freeze Atari dropdown, and load KVK
        // atariCodeStr "0" is stored for non-Atari logins — only treat as valid if numeric value > 0
        if (["10", "11", "12"].includes(userType) && atariCodeStr && Number(atariCodeStr) > 0) {
            setSelectedUserType('9');
            setAtariValue(String(atariCodeStr));
            setIsAtariFrozen(true);
            fetchAtariData();
            fetchKvkData(atariCodeStr);
            // KVK login: also pre-fill and freeze the KVK dropdown
            const kvkCodeStr = sessionStorage.getItem("kvkCode");
            if (kvkCodeStr && Number(kvkCodeStr) > 0) {
                setKvkValue(String(kvkCodeStr));
                setIsKvkFrozen(true);
            }
        }
        // ICAR login (no atariCode): freeze Scheme Type to ICAR, allow Atari/KVK selection
        if (userType === "9") {
            setSelectedUserType('9');
            fetchAtariData();
        }
    }, []);

    // Once districts are loaded and we have a desired district code, set it
    useEffect(() => {
        if (desiredDistrictCode && optionDistrict && optionDistrict.length > 0) {
            // Try to match by district code first
            let match = optionDistrict.find(o => Number(o.value) === Number(desiredDistrictCode));
            
            // If no match by code, try matching by district name (case-insensitive)
            if (!match && isNaN(Number(desiredDistrictCode))) {
                match = optionDistrict.find(o => 
                    o.label && o.label.toLowerCase() === String(desiredDistrictCode).toLowerCase()
                );
            }
            
            if (match) {
                handleChangeDistrict(match);
                setDesiredDistrictCode(null);
                // Don't fetch here - let the next useEffect handle it after state updates
            }
        }
    }, [optionDistrict, desiredDistrictCode]);

    // For district users: once district is frozen and selectedDataSetDistrict is set, fetch data
    useEffect(() => {
        if (isDistrictFrozen && selectedDataSetDistrict && selectedDataSetDistrict !== '') {
            console.log("District frozen and district value set, fetching data...");
            fetchDataFilterWise();
            
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDistrictFrozen, selectedDataSetDistrict]);

    // For state users: once state is frozen and set, fetch data
    useEffect(() => {
        if (isStateFrozen && stateValue && stateValue.length > 0 && !desiredDistrictCode && !isDistrictFrozen) {
            // Prevent duplicate API calls for state users
            if (!hasCalledStateUserApi.current) {
                hasCalledStateUserApi.current = true;
                fetchDataFilterWise();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isStateFrozen, stateValue, isDistrictFrozen, desiredDistrictCode]);

    // Central users (role "1") do NOT auto-fetch on load — they must click Submit first

    // Auto-fetch for Atari login (role "10"): once atariValue is pre-filled and frozen
    useEffect(() => {
        const userType = sessionStorage.getItem("userRoleCodeModel");
        if (userType === "10" && isAtariFrozen && atariValue && atariValue !== "NA") {
            if (!hasCalledAtariUserApi.current) {
                hasCalledAtariUserApi.current = true;
                fetchDataFilterWise();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAtariFrozen, atariValue]);

    // Auto-fetch for KVK login (role "11"): once both atariValue and kvkValue are pre-filled and frozen
    useEffect(() => {
        const userType = sessionStorage.getItem("userRoleCodeModel");
        if (userType === "11" && isAtariFrozen && isKvkFrozen && atariValue && atariValue !== "NA" && kvkValue && kvkValue !== "NA") {
            if (!hasCalledKvkUserApi.current) {
                hasCalledKvkUserApi.current = true;
                fetchDataFilterWise();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAtariFrozen, isKvkFrozen, atariValue, kvkValue]);

    // Auto-fetch for ICAR login (role "9"): once selectedUserType is set to '9' on page load
    useEffect(() => {
        const userType = sessionStorage.getItem("userRoleCodeModel");
        if (userType === "9" && selectedUserType === '9') {
            if (!hasCalledIcarUserApi.current) {
                hasCalledIcarUserApi.current = true;
                fetchDataFilterWise();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedUserType]);

    function getStates() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            redirect: "follow",
        };
        fetch(
            `${baseUrl}/api/states`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => {
                let localFormDataState = JSON.parse(result).dataContent || [];
                let myArray = [];
                localFormDataState.map((item) => {
                    myArray.push({
                        value: item.stateCode,
                        label: item.stateName,
                    });
                });
                setOptionState(myArray);
            })
            .catch((error) => {
                console.error("Error fetching states:", error);
            });
    }

    const fetchAtariData = async () => {
        try {
            console.log("Fetching Atari data...");
            const response = await axios.get(
                `${baseUrl}/api/MT/GetAtari`
            );
            
            console.log("Atari API response:", response.data);
            if (response.data && response.data.dataContent) {
                const atariList = response.data.dataContent;
                console.log("Atari data loaded:", atariList);
                setAtariData(atariList);
            } else {
                console.error("Invalid or empty Atari data received");
                alert("Error loading Atari data. Please try refreshing the page.");
            }
        } catch (error) {
            console.error("Error fetching Atari data:", error);
            alert("Error loading Atari data. Please try refreshing the page.");
        }
    };

    const fetchKvkData = async (atariCode) => {
        try {
            if (!atariCode || atariCode === "NA") {
                setKvkData([]);
                setKvkValue("NA");
                return;
            }

            const apiUrl = `${
                process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
            }/api/MT/GetKvk`;

            const response = await axios.post(
                apiUrl,
                {
                    ataricode: String(atariCode || "0"),
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                }
            );

            if (response.data && response.data.success && response.data.dataContent) {
                setKvkData(response.data.dataContent);
            } else {
                setKvkData([]);
            }
        } catch (error) {
            console.error("Error fetching KVK data:", error);
            setKvkData([]);
        }
    };

    const fetchFmttiCentreData = async () => {
        try {
            const res = await axios.get(
                `${baseUrl}/api/MT/GetFmtti`,
                { headers: { accept: "*/*" } }
            );
            setFmttiCentreData(res.data?.dataContent || []);
        } catch (err) {
            console.error("Error fetching FMTTI centre list:", err);
            setFmttiCentreData([]);
        }
    };

    function handleState(stateCodeParam = null) {
        const currentStateValue = stateCodeParam ? [stateCodeParam] : stateValue;
        setOptionDistrict([]);
        setDistrictValue('');
        setOptionSubDistrict([]);
        setsubDistrictValue('');
        setOptionVillage([]);
        setvillageValue('');

        if (currentStateValue && currentStateValue.length > 0) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            let stateValueData = "";
            currentStateValue.map((item) => { stateValueData = stateValueData + item + ","; });
            stateValueData = stateValueData.slice(0, -1);

            var raw = JSON.stringify({ stateCode: stateValueData.toString() });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            fetch(
                `${baseUrl}/api/district`,
                requestOptions
            )
                .then((response) => response.text())
                .then((result) => {
                    let localFormDataDistrict = JSON.parse(result).dataContent || [];
                    let myArrayDistrict = [];
                    
                    // Filter districts for district users to only show assigned districts
                    const userType = sessionStorage.getItem("userRoleCodeModel");
                    const districtCodeStr = sessionStorage.getItem("districtCodeModel");
                    
                    if (userType === "3" && districtCodeStr) {
                        // District user: filter to only assigned districts
                        const assignedDistrictCodes = String(districtCodeStr).split(',').map(code => code.trim());
                        
                        localFormDataDistrict = localFormDataDistrict.filter(item => 
                            assignedDistrictCodes.includes(String(item.districtCode))
                        );
                    }
                    
                    localFormDataDistrict.map((item) => {
                        myArrayDistrict.push({ label: item.districtName, value: item.districtCode, stateid: item.stateCode })
                    })
                    setOptionDistrict(myArrayDistrict);
                })
                .catch((error) => console.log("error", error));
        }
    }

    let handleChangeDistrict = (selectedOption) => {
        setOptionSubDistrict([]);
        setsubDistrictValue('');
        setOptionVillage([]);
        setvillageValue('');

        if (selectedOption) {
            setDistrictValue(selectedOption.value);
            setselectedDataSetDistrict(`${selectedOption.stateid}|${selectedOption.value}`);

            let stateValueData = stateValue[0];
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var raw = JSON.stringify({
                stateCode: stateValueData?.toString() || "0",
                districtCode: selectedOption.value?.toString() || "0"
            });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            fetch(
                `${baseUrl}/api/subdistrict`,
                requestOptions
            )
                .then((response) => response.text())
                .then((result) => {
                    let localFormDataSubDistrict = JSON.parse(result).dataContent || [];
                    let myArraySubDistrict = [];
                    localFormDataSubDistrict.map((item) => {
                        myArraySubDistrict.push({ label: item.subDistrictName, value: item.subDistrictCode, districtCode: item.districtCode })
                    });
                    setOptionSubDistrict(myArraySubDistrict);
                })
                .catch((error) => console.log("error", error));
        } else {
            setDistrictValue('');
            setselectedDataSetDistrict('');
            setOptionSubDistrict([]);
        }
    };

    let handleChangeSubDistrict = (selectedOption) => {
        setOptionVillage([]);
        setvillageValue('');
        if (selectedOption) {
            setsubDistrictValue(selectedOption.value);
            setselectedDataSetSubDistrict(`${selectedOption.districtCode}|${selectedOption.value}`);

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            let stateValueData = stateValue[0] || 0;
            let districtValueData = districtValue || 0;
            var raw = JSON.stringify({
                stateCode: stateValueData.toString(),
                districtCode: districtValueData.toString(),
                subDistrictCode: selectedOption.value.toString()
            });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            fetch(
                `${baseUrl}/api/village`,
                requestOptions
            )
                .then((response) => response.text())
                .then((result) => {
                    let localFormDataVillage = JSON.parse(result).dataContent || [];
                    let myArrayVillage = [];
                    localFormDataVillage.map((item) => {
                        myArrayVillage.push({ label: item.villageName, value: item.villageCode, subDistrictCode: item.subDistrictCode })
                    })
                    setOptionVillage(myArrayVillage)
                })
                .catch((error) => console.log("error", error));
        } else {
            setsubDistrictValue('');
            setselectedDataSetSubDistrict('');
        }
    };

    let handleChangeVillage = (selectedOption) => {
        if (selectedOption) {
            setvillageValue(selectedOption.value);
            setselectedDataSetVillage(`${selectedOption.subDistrictCode}|${selectedOption.value}`);
        } else {
            setvillageValue('');
            setselectedDataSetVillage('');
        }
    };

    let handleChangeStateSelect = (selectedOption) => {
        if (isStateFrozen) {
            return; // Prevent changes when frozen
        }
        setStateValue(selectedOption ? [selectedOption.value] : []);
        setErrorMessage('');
        if (!selectedOption) {
            setOptionDistrict([]);
            setDistrictValue('');
            setOptionSubDistrict([]);
            setsubDistrictValue('');
            setOptionVillage([]);
            setvillageValue('');
            setselectedDataSetDistrict('');
            setselectedDataSetSubDistrict('');
            setselectedDataSetVillage('');
            setRows([]);
        } else {
            // load districts
            handleState(selectedOption.value);
        }
    };

    // Convert UI finYear like "2023-2024" to API format "2023-24"
    // Returns 0 (number) when empty, or formatted string when provided
    const formatFinYearForApi = (value) => {
        if (!value || value === 'All') return 0;
        const str = String(value).trim();
        if (str === '') return 0;
        const match = str.match(/^(\d{4})-(\d{2,4})$/);
        if (!match) return str; // already in desired shape or unsupported
        const start = match[1];
        const endTwo = match[2].slice(-2);
        return `${start}-${endTwo}`;
    };

    const fetchDataFilterWise = async () => {
        // Require scheme selection for non-ICAR users (ICAR has it frozen to '9')
        if (!isIcarLogin && (!selectedUserType || selectedUserType === '')) {
            setRows([]);
            setErrorMessage('Please select Scheme Type to view data.');
            return;
        }
        setLoading(true);
        setRows([]);
        try {
            // Determine userTypeCode based on user role
            const userRoleCode = sessionStorage.getItem("userRoleCodeModel");
            let userTypeCodeToSend = 0;
            if (selectedUserType && selectedUserType !== '' && selectedUserType !== 'All') {
                // Dropdown selection takes priority for all login types
                // (ICAR endpoint overrides this to 0 separately below)
                userTypeCodeToSend = Number(selectedUserType);
            } else if (userRoleCode !== "1") {
                // Non-Central login with no specific scheme selected: fall back to session type
                const userTypeCodeFromSession = sessionStorage.getItem("userTypeCodeModel");
                userTypeCodeToSend = userTypeCodeFromSession ? Number(userTypeCodeFromSession) : 0;
            }

            const finYearToSend = (selectedFinYear && selectedFinYear !== 'All') ? selectedFinYear : (finYear || "");
            // For ICAR API: send fyName exactly as "2025-2026" or empty
            const finYearApi = (!finYearToSend || finYearToSend === 'All') ? "" : finYearToSend;

            let requestUrl = `${baseUrl}/api/MT/MachinDemonstrationSurveyDetail`;
            let payload = {};

            if (isIcarSelected) {
                // ICAR-specific API: use Atari/KVK codes; userTypeCode must be 0 for ICAR endpoint
                const atariIdToSend = atariValue && atariValue !== "NA" ? Number(atariValue) : 0;
                const kvkCodeToSend = kvkValue && kvkValue !== "NA" ? Number(kvkValue) : 0;

                requestUrl = `${baseUrl}/api/MT/MachinDemonstrationSurveyDetail_ICAR`;
                payload = {
                    fyName: String(finYearApi),
                    atari_id: atariIdToSend,
                    kvkcode: kvkCodeToSend,
                    userTypeCode: 0
                };
            } else if (isFmttiSelected) {
                // FMTTI: filter by selected centre (payload matches new API format)
                const fmttiCodeToSend = fmttiCentreValue && fmttiCentreValue !== "NA" ? Number(fmttiCentreValue) : 0;
                const finYearNum = (!finYearApi || finYearApi === '') ? 0 : finYearApi;
                payload = {
                    stateCode: 0,
                    districtCode: 0,
                    blockCode: 0,
                    villageCode: 0,
                    FyName: String(finYearApi),
                  //  finYear: finYearNum,
                    userTypeCode: userTypeCodeToSend,
                    fmttiCode: 1
                };
            } else {
                // Existing non-ICAR behaviour (state/district/sub-district/village filters)
                let stateCodeData = (stateValue && stateValue.length > 0) ? Number(stateValue[0]) : 0;
                let districtCodeData = 0;
                let subDistrictCodeData = 0;
                let villageCodeData = 0;

                if (selectedDataSetDistrict !== '') {
                    const districtParts = selectedDataSetDistrict.split('|');
                    districtCodeData = Number(districtParts[1] || 0);
                }
                if (selectedDataSetSubDistrict !== '') {
                    const subParts = selectedDataSetSubDistrict.split('|');
                    subDistrictCodeData = Number(subParts[1] || 0);
                }
                if (selectedDataSetVillage !== '') {
                    const villParts = selectedDataSetVillage.split('|');
                    villageCodeData = Number(villParts[1] || 0);
                }

                const finYearNum = (!finYearApi || finYearApi === '') ? 0 : finYearApi;
                payload = {
                    FyName: String(finYearApi),
                    stateCode: stateCodeData,
                    districtCode: districtCodeData,
                    blockCode: subDistrictCodeData,
                    villageCode: villageCodeData,
                 //   finYear: finYearNum,
                 fmttiCode: 0,  
                    userTypeCode: userTypeCodeToSend
                };
            }

            const res = await axios.post(requestUrl, payload, {
                headers: { 'Content-Type': 'application/json', accept: '*/*' }
            });

            const content = res?.data?.dataContent ?? [];
            setRows(Array.isArray(content) ? content : []);
        } catch (e) {
            setErrorMessage('No data or request failed.');
        } finally {
            setLoading(false);
        }
    };

    function ValidateAndSearch() {
        setErrorMessage('');
        if (!isIcarLogin && (!selectedUserType || selectedUserType === '')) {
            setErrorMessage('Please select Scheme Type to view data.');
            return;
        }
        setHasSearched(true);
        fetchDataFilterWise();
    }

    function ClearSearch() {
        setFinYear('');
        setSelectedFinYear('All');
        if (!isIcarLogin && !isFmttiLoginUserType1) {
            setSelectedUserType('');
        }
        setAtariValue("NA");
        setAtariData([]);
        setKvkValue("NA");
        setKvkData([]);
        setFmttiCentreValue("NA");
        setFmttiCentreData([]);
        setSelectedIcarOrgType('All');
        if (!isStateFrozen) {
            setStateValue([]);
        }
        setOptionDistrict([]);
        if (!isDistrictFrozen) {
            setDistrictValue('');
        }
        setOptionSubDistrict([]);
        setsubDistrictValue('');
        setOptionVillage([]);
        setvillageValue('');
        if (!isDistrictFrozen) {
            setselectedDataSetDistrict('');
        }
        setselectedDataSetSubDistrict('');
        setselectedDataSetVillage('');
        setRows([]);
        setErrorMessage('');
    }

    // Handlers for modals

    const handleImplementsClick = (row) => {
        setSelectedImplements(row);
        setShowImplementsModal(true);
    };

    const closeImplementsModal = () => {
        setShowImplementsModal(false);
        setSelectedImplements(null);
    };

    const handlePolygonClick = (rowData) => {
        setSelectedPolygon(rowData);
        setImageRotations({});
        setShowPolygonModal(true);
    };

    const closePolygonModal = () => {
        setShowPolygonModal(false);
        setSelectedPolygon(null);
        setCurrentDetailImageIndex(0);
        setImageRotations({});
        setPolygonMap(null);
        setPolygonMapReady(false);
    };

    const handleNextDetailImage = () => {
        setCurrentDetailImageIndex((prevIndex) =>
            prevIndex < detailImages.length - 1 ? prevIndex + 1 : prevIndex
        );
    };

    const handlePrevDetailImage = () => {
        setCurrentDetailImageIndex((prevIndex) =>
            prevIndex > 0 ? prevIndex - 1 : prevIndex
        );
    };

    const rotateDetailImage = (index, delta) => {
        setImageRotations((prev) => {
            const current = prev[index] || 0;
            return { ...prev, [index]: (current + delta + 360) % 360 };
        });
    };

    // Defer map render until modal is visible (fixes blank map in Bootstrap modal)
    useEffect(() => {
        if (!showPolygonModal || !selectedPolygon) {
            setPolygonMapReady(false);
            return;
        }
        const t = setTimeout(() => setPolygonMapReady(true), 200);
        return () => clearTimeout(t);
    }, [showPolygonModal, selectedPolygon]);

    // Trigger map resize when modal opens
    useEffect(() => {
        if (!showPolygonModal || !polygonMap) return;
        const timer = setTimeout(() => {
            try {
                window.google?.maps?.event?.trigger(polygonMap, 'resize');
            } catch (e) {
                console.warn('Map resize trigger failed:', e);
            }
        }, 150);
        return () => clearTimeout(timer);
    }, [showPolygonModal, polygonMap]);

    useEffect(() => {
        setCurrentDetailImageIndex(0);
        setImageRotations({});
    }, [selectedPolygon?.imagePaths, showPolygonModal]);

    const renderRows = () => {
        if (!rows || rows.length === 0) return null;

        const columns = [
            { key: 'fyName', label: 'Fin Year', style: { whiteSpace: 'nowrap', width: '90px', minWidth: '90px' } },
            { key: 'mobileNo', label: 'Mob No.' },
            { key: 'farmerName', label: 'Farmer Name',style: { whiteSpace: 'nowrap', width: '90px', minWidth: '90px' } },
            // Atari/KVK only for ICAR scheme type
            ...(isIcarSelected ? [
                { key: 'atari_Name', label: 'Atari Name' },
                { key: 'kvK_Name', label: 'KVK Name' },
            ] : []),
            // FMTTI columns only for FMTTI scheme type
            ...(isFmttiSelected ? [
                { key: 'fmttI_Name', label: 'FMTTI Name' },
                { key: 'fmttiImplementCategoryName', label: 'FMTTI Implement Category' },
                { key: 'fmttiImplementName', label: 'FMTTI Implement Name' },
            ] : []),
            { key: 'stateName', label: 'State' },
            { key: 'districtName', label: 'District' },
            { key: 'blockName', label: 'Block' },
            { key: 'villageName', label: 'Village' },
            { key: 'schemeName', label: 'Scheme' },
            // { key: 'noOfImplements', label: 'Number of Implement' },
            { key: 'polygonShape', label: 'Detail ' },
        ];

        const getValue = (row, key) => {
            if (key === 'subdistrictName') {
                return row.subdistrictName ?? row.subDistrictName ?? '';
            }
            if (key === 'polygonShape') {
                return row.polygonShape ?? row.polygon_shape ?? '';
            }
            if (key === 'fmttI_Name') {
                return row.fmttI_Name ?? row.fmttiName ?? row.fmtti_Name ?? '';
            }
            return row[key] ?? '';
        };

        const handleSort = (key) => {
            if (sortKey === key) {
                setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
            } else {
                setSortKey(key);
                setSortDir('asc');
            }
            setCurrentPage(1);
        };

        const exportToCsv = () => {
            const exportColumns = columns.filter(c => c.key !== 'polygonShape');
            const header = exportColumns.map(c => c.label).join(',');
            const allRows = rows.map(r => exportColumns.map(c => {
                const val = String(getValue(r, c.key)).replace(/"/g, '""');
                return `"${val}"`;
            }).join(','));
            const csv = [header, ...allRows].join('\n');
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'survey_detail.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        };

        const sortedRows = (() => {
            if (!sortKey) return rows;
            const data = [...rows];
            data.sort((a, b) => {
                const av = String(getValue(a, sortKey)).toLowerCase();
                const bv = String(getValue(b, sortKey)).toLowerCase();
                if (av < bv) return sortDir === 'asc' ? -1 : 1;
                if (av > bv) return sortDir === 'asc' ? 1 : -1;
                return 0;
            });
            return data;
        })();

        const totalItems = sortedRows.length;
        const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
        const safePage = Math.min(currentPage, totalPages);
        const startIndex = (safePage - 1) * pageSize;
        const pageRows = sortedRows.slice(startIndex, startIndex + pageSize);

        const goToPage = (p) => {
            const np = Math.min(Math.max(1, p), totalPages);
            setCurrentPage(np);
        };

        return (
            <div className="table-responsive">
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <div className="d-flex align-items-center gap-2">
                        <label className="me-2">Page size</label>
                        <select
                            className="form-select form-select-sm"
                            style={{ width: 90 }}
                            value={pageSize}
                            onChange={(e) => { setPageSize(Number(e.target.value)); setCurrentPage(1); }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                        <span className="ms-3">Total: {totalItems}</span>
                    </div>
                    <button type="button" className="btn btn-outline-primary btn-sm" onClick={exportToCsv}>Export CSV</button>
                </div>
                <table className="table table-bordered table-striped table-sm">
                    <thead>
                        <tr>
                            {columns.map((c) => (
                                <th
                                    key={c.key}
                                    role="button"
                                    onClick={() => handleSort(c.key)}
                                    title="Click to sort"
                                    style={c.style || {}}
                                >
                                    {c.label}
                                    {sortKey === c.key ? (
                                        <span className="ms-1">{sortDir === 'asc' ? '▲' : '▼'}</span>
                                    ) : null}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {pageRows.map((r, idx) => (
                            <tr key={idx}>
                                {columns.map((c) => (
                                    <td key={c.key} style={c.style || {}}>
                                        {c.key === 'noOfImplements' ? (
                                            <a 
                                                href="#" 
                                                onClick={(e) => { e.preventDefault(); handleImplementsClick(r); }}
                                                className="text-primary"
                                                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                            >
                                                {String(getValue(r, c.key))}
                                            </a>
                                        ) : c.key === 'polygonShape' ? (
                                            getValue(r, c.key) ? (
                                                <button 
                                                    className="btn btn-sm btn-link p-0" 
                                                    onClick={() => handlePolygonClick(r)}
                                                    title="View Polygon"
                                                >
                                                    <i className="bi bi-eye-fill" style={{ fontSize: '1.2rem', color: '#28a745' }}></i>
                                                </button>
                                            ) : (
                                                <span>No Data</span>
                                            )
                                        ) : (
                                            String(getValue(r, c.key))
                                        )}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="d-flex align-items-center justify-content-between">
                    <div>
                        Page {safePage} of {totalPages}
                    </div>
                    <div className="btn-group btn-group-sm" role="group">
                        <button type="button" className="btn btn-outline-secondary" onClick={() => goToPage(1)} disabled={safePage === 1}>{'<<'}</button>
                        <button type="button" className="btn btn-outline-secondary" onClick={() => goToPage(safePage - 1)} disabled={safePage === 1}>{'<'}</button>
                        <button type="button" className="btn btn-outline-secondary" onClick={() => goToPage(safePage + 1)} disabled={safePage === totalPages}>{'>'}</button>
                        <button type="button" className="btn btn-outline-secondary" onClick={() => goToPage(totalPages)} disabled={safePage === totalPages}>{'>>'}</button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <AdminHeaderNew />
            <AdminSideBarNew />

            <main id="main" className="main">
                <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
                    <nav>
                        <h1>Survey List</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Survey</li>
                            <li className="breadcrumb-item active">Machine Demonstration Survey Detail</li>
                            <li className="breadcrumb-item">
                                {(() => {
                                    const userTypeCode = Number(sessionStorage.getItem("userTypeCodeModel"));
                                    switch(userTypeCode) {
                                        case 1: return "FMTTI";
                                        case 2: return "CRM";
                                        case 3: return "SMAM";
                                        default: return "ICAR";
                                        
                                        
                                    }
                                })()}
                            </li>
                        </ol>
                    </nav>
                </div>

                <section className="section">
                    <div className="row surveydetailsBg">
                        <div className="col-md-2">
                            <label htmlFor="finYear" className="form-label">Fin Year</label>
                            <Select
                                options={finYears.map(y => ({ label: y, value: y }))}
                                value={selectedFinYear ? { value: selectedFinYear, label: selectedFinYear } : null}
                                onChange={(opt) => setSelectedFinYear(opt ? opt.value : 'All')}
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select Fin Year"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>{children}</components.Option>
                                    )
                                }}
                            />
                        </div>
                                   <div className='col-md-2'>
                            <label htmlFor="Type" className="form-label">Scheme Type</label>
                            <Select
                                options={
                                    isFmttiLoginUserType1
                                        ? [{ label: 'FMTTI', value: '1' }]
                                        : [
                                            { label: 'Choose', value: '' },
                                            ...(isStateLoginUserType2 ? [] : [{ label: 'FMTTI', value: '1' }]),
                                            { label: 'CRM', value: '2' },
                                            { label: 'ICAR', value: '9' },
                                          ]
                                }
                               // isDisabled={isIcarLogin || isFmttiLoginUserType1}
                                value={selectedUserType ? { value: selectedUserType, label: selectedUserType === '1' ? 'FMTTI' : selectedUserType === '2' ? 'CRM' : selectedUserType === '9' ? 'ICAR' : 'Choose' } : { value: '', label: 'Choose' }}
                                onChange={handleSchemeTypeChange}
                                isClearable={!isIcarLogin && !isFmttiLoginUserType1}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select Type"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>{children}</components.Option>
                                    )
                                }}
                            />
                        </div>

                        {isFmttiSelected && (
                            <div className='col-md-3'>
                                <label className="form-label">FMTTI Centre</label>
                                <select
                                    className='form-select'
                                    value={fmttiCentreValue}
                                    onChange={(e) => setFmttiCentreValue(e.target.value)}
                                >
                                    <option value="NA">Choose...</option>
                                    {fmttiCentreData.map((item, index) => (
                                        <option key={index} value={item.fmtticode}>
                                            {item.fmttiname}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {isIcarSelected && (
                            <>
                                <div className='col-md-3'>
                                    <label className="form-label">Select Atari</label><label style={{ color: "red" }}>*</label>
                                    <select
                                        className='form-select'
                                        value={atariValue}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setAtariValue(value);
                                            setKvkValue("NA");
                                            setKvkData([]);
                                            fetchKvkData(value);
                                        }}
                                        disabled={["10", "11"].includes(sessionStorage.getItem("userRoleCodeModel")) && isAtariFrozen}
                                    >
                                        <option value="NA">Choose...</option>
                                        {atariData.map((item, index) => (
                                            <option key={index} value={item.ataricode}>
                                                {item.atariname}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* KVK Dropdown for ICAR (ATARI) */}
                                <div className='col-md-3'>
                                    <label className="form-label">Select KVK</label><label style={{ color: "red" }}>*</label>
                                    <select
                                        className='form-select'
                                        value={kvkValue}
                                        onChange={(e) => setKvkValue(e.target.value)}
                                        disabled={sessionStorage.getItem("userRoleCodeModel") === "11" && isKvkFrozen && isAtariFrozen}
                                        // disabled={atariValue === "NA" || isKvkFrozen}
                                    >
                                        <option value="NA">Choose...</option>
                                        {kvkData && kvkData.map((item, index) => (
                                            <option key={index} value={item.kvkcode}>
                                                {item.kvkname}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </>
                        )}
                         {!isIcarSelected && !isFmttiSelected && (
                            <>
                        <div className="col-md-3">
                            <label htmlFor="State" className="form-label">State</label>
                            <Select
                                options={stateOptionsForUi}
                                value={stateValue && stateValue.length > 0 ? stateOptionsForUi.find(option => option.value === stateValue[0]) : null}
                                onChange={handleChangeStateSelect}
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select State"
                                classNamePrefix="select"
                                isDisabled={isStateFrozen}
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>{children}</components.Option>
                                    )
                                }}
                            />
                        </div>

                       
                                <div className="col-md-3">
                                    <label htmlFor="District" className="form-label">District</label>
                                    <Select
                                        options={optionDistrict}
                                        value={optionDistrict.find(option => option.value === districtValue)}
                                        onChange={handleChangeDistrict}
                                        isClearable={true}
                                        isSearchable={true}
                                        placeholder="Select District"
                                        classNamePrefix="select"
                                        isDisabled={isDistrictFrozen}
                                        components={{
                                            Option: ({ children, ...props }) => (
                                                <components.Option {...props}>{children}</components.Option>
                                            )
                                        }}
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label htmlFor="SubDistrict" className="form-label">Sub District</label>
                                    <Select
                                        options={optionSubDistrict}
                                        value={optionSubDistrict.find(option => option.value === subdistrictValue)}
                                        onChange={handleChangeSubDistrict}
                                        isClearable={true}
                                        isSearchable={true}
                                        isMulti={false}
                                        hideSelectedOptions={false}
                                        placeholder="Select Sub District"
                                        classNamePrefix="select"
                                        components={{
                                            Option: ({ children, ...props }) => (
                                                <components.Option {...props}>{children}</components.Option>
                                            )
                                        }}
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label htmlFor="Village" className="form-label">Village</label>
                                    <Select
                                        options={optionVillage}
                                        value={optionVillage.find(option => option.value === villageValue)}
                                        onChange={handleChangeVillage}
                                        isClearable={true}
                                        isSearchable={true}
                                        isMulti={false}
                                        hideSelectedOptions={false}
                                        placeholder="Select Village"
                                        classNamePrefix="select"
                                        components={{
                                            Option: ({ children, ...props }) => (
                                                <components.Option {...props}>{children}</components.Option>
                                            )
                                        }}
                                    />
                                </div>
                            </>
                        )}
                     

                        <div className="col-md-12 d-flex justify-content-md-center mt-3">
                            <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={ValidateAndSearch} disabled={loading}>{loading ? 'Searching...' : 'Submit'}</button>
                            <button type="button" className="btn btn-success me-md-2" onClick={ClearSearch}>Clear</button>
                        </div>
                    </div>

                    {errorMessage && (
                        <div className="alert alert-danger mt-3" role="alert">{errorMessage}</div>
                    )}

                    <div className="row mt-3">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    {hasSearched && rows.length > 0 ? (
                                        renderRows()
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {loading === false ? "" : <div className="overlay"><div className="overlay__inner"><div className="overlay__content"><span className="spinner"></span></div></div></div>}
                
                {/* Polygon Modal */}
                {showPolygonModal && selectedPolygon && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={closePolygonModal}>
                        <div className="modal-dialog modal-dialog-centered modal-xl" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Details</h5>
                                    <button type="button" className="btn-close" onClick={closePolygonModal}>x</button>
                                </div>
                                <div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                                    {/* {loadError ? (
                                        <div style={{ width: "100%", height: "50vh", display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8f9fa', flexDirection: 'column', gap: '1rem', padding: '1rem', textAlign: 'center' }}>
                                            <p className="text-danger mb-0"><strong>Map could not be loaded.</strong></p>
                                            <p className="text-muted small mb-0">If you see &quot;quota limit reached&quot;, add <code>REACT_APP_GOOGLE_MAPS_API_KEY=your_key</code> in .env and restart. Otherwise ensure Maps JavaScript API is enabled and your key allows this domain.</p>
                                        </div>
                                    ) : isLoaded && polygonMapReady ? (
                                        <div style={{ width: "100%", height: "50vh", minHeight: "400px" }}>
                                        <GoogleMap
                                            key={selectedPolygon?.farmerID ?? selectedPolygon?.farmerCode ?? 'poly'}
                                            mapContainerStyle={{ width: "100%", height: "50vh", minHeight: "400px" }}
                                            center={polygonMapCenter}
                                            zoom={18}
                                            onLoad={(map) => {
                                                setPolygonMap(map);
                                                try {
                                                    const raw = selectedPolygon.polygonShape;
                                                    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
                                                    // Normalise: support both {lat,lng} and {latitude,longitude}
                                                    const polygonData = Array.isArray(parsed)
                                                        ? parsed.map(p => ({
                                                            lat: Number(p.lat ?? p.latitude ?? p.Lat ?? p.Latitude),
                                                            lng: Number(p.lng ?? p.longitude ?? p.Lng ?? p.Longitude),
                                                          }))
                                                        : [];

                                                    if (polygonData.length === 0) {
                                                        console.warn("Polygon data is empty or unrecognised format:", parsed);
                                                        return;
                                                    }

                                                    const polygon = new window.google.maps.Polygon({
                                                        paths: polygonData,
                                                        strokeColor: "#FF0000",
                                                        strokeOpacity: 1,
                                                        strokeWeight: 2,
                                                        fillColor: "#FF0000",
                                                        fillOpacity: 0.1,
                                                    });
                                                    polygon.setMap(map);
                                                    
                                                    const bounds = new window.google.maps.LatLngBounds();
                                                    polygonData.forEach(point => {
                                                        bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
                                                    });
                                                    map.fitBounds(bounds);
                                                } catch (error) {
                                                    console.error("Error rendering polygon:", error);
                                                }
                                            }}
                                            onUnmount={() => setPolygonMap(null)}
                                            mapTypeId="satellite"
                                        />
                                        </div>
                                    ) : (
                                        <div style={{ width: "100%", height: "50vh", minHeight: "400px", display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f0f0' }}>
                                            <div className="text-center">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <p className="mt-2">Loading map...</p>
                                            </div>
                                        </div>
                                    )}
                                     */}
                                    <div className="mt-4">
                                        <h6 className="mb-3"><strong>Survey Details</strong></h6>
                                        <div className="row surveydetailsbg">
                                            {/* <div className="col-md-3 mb-3">
                                                <h6>CHC Name</h6>
                                                <p>{selectedPolygon.chcName || 'N/A'}</p>
                                            </div> */}
                                            <div className="col-md-3 mb-3">
                                                <h6>Farmer Name</h6>
                                                <p>{selectedPolygon.farmerName}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Mobile Number</h6>
                                                <p>{selectedPolygon.mobileNo}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Financial Year</h6>
                                                <p>{selectedPolygon.fyName}</p>
                                            </div>
                                        </div>
                                        
                                        <h6 className="mb-3 mt-3"><strong>Location Details</strong></h6>
                                        <div className="row surveydetailsbg">
                                            <div className="col-md-3 mb-3">
                                                <h6>State</h6>
                                                <p>{selectedPolygon.stateName}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>District</h6>
                                                <p>{selectedPolygon.districtName}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Sub District</h6>
                                                <p>{selectedPolygon.subdistrictName || selectedPolygon.subDistrictName || 'N/A'}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Village</h6>
                                                <p>{selectedPolygon.villageName}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Landmark Address</h6>
                                                <p>{selectedPolygon.landMarkAddress}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Area Type</h6>
                                                <p>{selectedPolygon.areaType === "1" ? "Rural" : selectedPolygon.areaType === "2" ? "Urban" : 'N/A'}</p>
                                            </div>
                                        </div>
                                        
                                        {/* <h6 className="mb-3 mt-3"><strong>Polygon Information</strong></h6>
                                        <div className="row surveydetailsbg">
                                            <div className="col-md-3 mb-3">
                                                <h6>Polygon Area (sq.m)</h6>
                                                <p>{selectedPolygon.polygonArea}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Image Latitude</h6>
                                                <p>{selectedPolygon.imageLat}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Image Longitude</h6>
                                                <p>{selectedPolygon.imageLong}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Surveyor Latitude</h6>
                                                <p>{selectedPolygon.surveyorLat}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Surveyor Longitude</h6>
                                                <p>{selectedPolygon.surveyorLong}</p>
                                            </div>
                                        </div> */}
                                        
                                        <h6 className="mb-3 mt-3"><strong>Additional Details</strong></h6>
                                        <div className="row surveydetailsbg">
                                            {(selectedPolygon.schemeName || '').toUpperCase().includes('CRM') ? (
                                                <>
                                                    <div className="col-md-3 mb-3">
                                                        <h6>Implement Category</h6>
                                                        <p>{selectedPolygon.crmCategoryName || 'N/A'}</p>
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <h6>Implement Name</h6>
                                                        <p>{selectedPolygon.usedMachineName || 'N/A'}</p>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="col-md-3 mb-3">
                                                        <h6>Implement Category</h6>
                                                        <p>{selectedPolygon.fmttiImplementCategoryName || 'N/A'}</p>
                                                    </div>
                                                    <div className="col-md-3 mb-3">
                                                        <h6>Implement Name</h6>
                                                        <p>{selectedPolygon.fmttiImplementName || 'N/A'}</p>
                                                    </div>
                                                </>
                                            )}
                                            {/* <div className="col-md-3 mb-3">
                                                <h6>Establishment Month</h6>
                                                <p>{selectedPolygon.monthName || 'N/A'}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Registration Number</h6>
                                                <p>{selectedPolygon.societyRegistrationNumber || 'N/A'}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>GST Number</h6>
                                                <p>{selectedPolygon.gsT_NO || 'N/A'}</p>
                                            </div> */}
                                            <div className="col-md-3 mb-3">
                                                <h6>Scheme Type</h6>
                                                <p>{selectedPolygon.schemeName}</p>
                                            </div>
                                            {/* <div className="col-md-3 mb-3">
                                                <h6>Under Scheme</h6>
                                                <p>{selectedPolygon.underSchemeName || 'N/A'}</p>
                                            </div> */}
                                            <div className="col-md-3 mb-3">
                                                <h6>Created Date</h6>
                                                <p>{selectedPolygon.createdOn ? selectedPolygon.createdOn.split('T')[0] : 'N/A'}</p>
                                            </div>
                                        </div>

                                        <h6 className="mb-3 mt-3"><strong>Survey Images</strong></h6>
                                        <div className="row surveydetailsbg">
                                            {detailImages.length > 0 ? (
                                                <div className="col-12">
                                                    <h6 className="mb-3">
                                                        Machine Demonstration Images {detailImages.length > 1 && `(${currentDetailImageIndex + 1} of ${detailImages.length})`}
                                                    </h6>
                                                    <div className="position-relative text-center" style={{ minHeight: '400px' }}>
                                                        <img
                                                            src={detailImages[currentDetailImageIndex]}
                                                            alt={`Survey ${currentDetailImageIndex + 1}`}
                                                            style={{
                                                                maxWidth: isDetailImageSideways ? '70vh' : '100%',
                                                                maxHeight: isDetailImageSideways ? '100%' : '70vh',
                                                                objectFit: 'contain',
                                                                borderRadius: '6px',
                                                                transform: `rotate(${detailImageRotation}deg)`,
                                                                transition: 'transform 0.3s ease'
                                                            }}
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="260" height="180"><rect width="100%" height="100%" fill="%23f2f2f2"/><text x="50%" y="50%" text-anchor="middle" dy=".3em" fill="%23999" font-size="14">Image not available</text></svg>';
                                                            }}
                                                        />

                                                        <div
                                                            className="d-flex gap-1"
                                                            style={{
                                                                position: 'absolute',
                                                                bottom: '8px',
                                                                left: '50%',
                                                                transform: 'translateX(-50%)',
                                                                background: 'rgba(0,0,0,0.55)',
                                                                borderRadius: '20px',
                                                                padding: '4px 6px',
                                                                zIndex: 2
                                                            }}
                                                        >
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-light rounded-circle"
                                                                title="Rotate left"
                                                                onClick={() => rotateDetailImage(currentDetailImageIndex, -90)}
                                                                style={{ width: '32px', height: '32px', padding: 0 }}
                                                            >
                                                                <i className="bi bi-arrow-counterclockwise"></i>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-light rounded-circle"
                                                                title="Rotate right"
                                                                onClick={() => rotateDetailImage(currentDetailImageIndex, 90)}
                                                                style={{ width: '32px', height: '32px', padding: 0 }}
                                                            >
                                                                <i className="bi bi-arrow-clockwise"></i>
                                                            </button>
                                                        </div>

                                                        {detailImages.length > 1 && (
                                                            <>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary position-absolute start-0 top-50 translate-middle-y ms-2"
                                                                    onClick={handlePrevDetailImage}
                                                                    disabled={currentDetailImageIndex === 0}
                                                                >
                                                                    <i className="bi bi-chevron-left"></i>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary position-absolute end-0 top-50 translate-middle-y me-2"
                                                                    onClick={handleNextDetailImage}
                                                                    disabled={currentDetailImageIndex === detailImages.length - 1}
                                                                >
                                                                    <i className="bi bi-chevron-right"></i>
                                                                </button>
                                                            </>
                                                        )}
                                                    </div>

                                                    {detailImages.length > 1 && (
                                                        <div className="d-flex gap-2 mt-3 flex-wrap">
                                                            {detailImages.map((_, index) => (
                                                                <button
                                                                    key={index}
                                                                    type="button"
                                                                    className={`btn btn-sm ${index === currentDetailImageIndex ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                                    onClick={() => setCurrentDetailImageIndex(index)}
                                                                    style={{ minWidth: '32px' }}
                                                                >
                                                                    {index + 1}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <div className="col-12">
                                                    <p className="mb-0">No image available</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={closePolygonModal}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                
                {/* Implements Details Modal */}
                {showImplementsModal && selectedImplements && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={closeImplementsModal}>
                        <div className="modal-dialog modal-dialog-centered modal-lg" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Implement Details</h5>
                                    <button type="button" className="btn-close" onClick={closeImplementsModal}>x</button>
                                </div>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <h6><strong>CHC Name:</strong> {selectedImplements.chcName || 'N/A'}</h6>
                                        <p className="mb-1"><strong>Total Implements:</strong> {selectedImplements.noOfImplements || 0}</p>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped">
                                            <thead className="table-light">
                                                <tr>
                                                    <th style={{ width: '10%' }}>S.No</th>
                                                    <th style={{ width: '45%' }}>Category Name</th>
                                                    <th style={{ width: '45%' }}>Implement Name</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(() => {
                                                    try {
                                                        const implementDetails = selectedImplements.implementDetailsJSON 
                                                            ? JSON.parse(selectedImplements.implementDetailsJSON) 
                                                            : [];
                                                        
                                                        if (implementDetails.length === 0) {
                                                            return (
                                                                <tr>
                                                                    <td colSpan="3" className="text-center">No implement details available</td>
                                                                </tr>
                                                            );
                                                        }
                                                        
                                                        return implementDetails.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{item.CategoryName || 'N/A'}</td>
                                                                <td>{item.ImplementName || 'N/A'}</td>
                                                            </tr>
                                                        ));
                                                    } catch (error) {
                                                        console.error('Error parsing implement details:', error);
                                                        return (
                                                            <tr>
                                                                <td colSpan="3" className="text-center text-danger">Error loading implement details</td>
                                                            </tr>
                                                        );
                                                    }
                                                })()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={closeImplementsModal}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </main>

            <AdminFooterNew />
        </>
    );
};

export default MachinSurveyReport;

 